import React from "react";

const EmbeddedVideoResult = (props) => {
    const srcMatch = props.item.embedCode?.match(/src="([^"]+)"/);
    let srcValue = srcMatch ? srcMatch[1] : null;

    if (srcValue?.startsWith("http://")) {
        srcValue = srcValue.replace("http://", "https://");
    } else if (!srcValue?.startsWith("https://")) {
        srcValue = srcValue ? `https://${srcValue}` : null;
    }

    const isValidUrl = (urlString) => {
        try {
            new URL(urlString);
            return true;
        } catch (e) {
            return false;
        }
    };

    const secureSrc = isValidUrl(srcValue) ? srcValue : null;

    return (
        <>
            {secureSrc ? (
                <a href={secureSrc} target="_blank" rel="noopener noreferrer">
                    <div className="poster">
                        <img src={props.item.posterUrl} alt={props.item.description} className="img-fluid" />
                    </div>
                    {props.item.title && <p>{props.item.title}</p>}
                </a>
            ) : null}            
        </>
    );
};

export default React.memo(EmbeddedVideoResult);
